import { apiClient } from '@/lib/apiClient';

export interface DocsHit {
  slug: string;
  title: string;
  heading: string;
  excerpt: string;
}

export interface DocPage {
  slug: string;
  title: string;
  section: string;
  summary: string;
  body: string;
  isFallback: boolean;
}

/** Passages matching a question. Empty when nothing is close enough — not "the nearest page". */
export const searchDocs = (q: string, limit = 6) =>
  apiClient.get<{ hits: DocsHit[]; available: boolean }>('/docs/search', { params: { q, limit } }).then((r) => r.data);

/** One guide in full, for reading in place. */
export const getDoc = (slug: string) => apiClient.get<DocPage>(`/docs/${slug}`).then((r) => r.data);
